import { Injectable, computed, inject, signal } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { GlobalSettingsProvider } from './global-settings-provider';

@Injectable({ providedIn: 'root' })
export class ThemeManager {
    readonly isDark = computed(() => this.isDarkSignal());

    private readonly isDarkSignal = signal(false);

    constructor() {
        const settings = inject(GlobalSettingsProvider);
        const prefersDarkQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const prefersDarkSubj = new BehaviorSubject(prefersDarkQuery.matches);

        if (prefersDarkQuery.addEventListener) {
            prefersDarkQuery.addEventListener('change', (ev) => prefersDarkSubj.next(ev.matches));
        } else {
            // handle certain backward browsers (cough) Safari (cough)
            prefersDarkQuery.addListener((ev) => prefersDarkSubj.next(ev.matches));
        }

        combineLatest([settings.themePolicyObs, prefersDarkSubj]).subscribe((t) => {
            const dark = { system: t[1], light: false, dark: true }[t[0]];
            const classList = document.documentElement.classList;
            if (dark) {
                classList.add('dark-mode');
                classList.remove('light-mode');
            } else {
                classList.add('light-mode');
                classList.remove('dark-mode');
            }
            this.isDarkSignal.set(dark);
        });
    }
}
